import { P2GGrid } from '@parcel2go/core-ui';
import { ReactNode } from 'react';

interface props {
  icon?: ReactNode;
  iconSrc?: string;
  children: ReactNode;
}
const DropItem: React.FC<props> = (props) => {
  return <P2GGrid item>{props.children}</P2GGrid>;
};

export default DropItem;
